export * from './IconPaste';
